export enum Overflow {
    Hidden = 'hidden',
    Scroll = 'scroll',
}
